import React, { useMemo, useState } from 'react';
import { Search, Star } from 'lucide-react';

function RoutePlannerPriorityList({ deliveries = [], selectedDate, onTogglePriority, onMarkPostponedPriority }) {
  const [query, setQuery] = useState('');
  const [mode, setMode] = useState('all');
  const postponed = useMemo(
    () => deliveries.filter((delivery) => String(delivery.status || '').toLowerCase() === 'postergado'),
    [deliveries]
  );
  const filtered = useMemo(() => {
    const term = query.trim().toLowerCase();
    const base = mode === 'postponed' ? postponed : deliveries;
    if (!term) return base;
    return base.filter((delivery) =>
      [delivery.id, delivery.recipient_name, delivery.customer_name, delivery.district, delivery.address]
        .some((field) => String(field || '').toLowerCase().includes(term))
    );
  }, [deliveries, mode, postponed, query]);

  return (
    <div>
      <div className="mb-2 flex items-center justify-between gap-2 text-xs text-slate-500">
        <span>{filtered.length} / {mode === 'postponed' ? postponed.length : deliveries.length}</span>
        <span>{selectedDate}</span>
      </div>
      <div className="mb-2 grid grid-cols-2 gap-1 rounded-lg bg-slate-100 p-1 text-xs font-bold">
        <button
          onClick={() => setMode('all')}
          className={`rounded-md px-2 py-1.5 ${mode === 'all' ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-500'}`}
        >
          Todas
        </button>
        <button
          onClick={() => setMode('postponed')}
          className={`rounded-md px-2 py-1.5 ${mode === 'postponed' ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-500'}`}
        >
          Postergados ({postponed.length})
        </button>
      </div>
      {mode === 'postponed' && (
        <button
          onClick={onMarkPostponedPriority}
          disabled={!postponed.length}
          className="mb-2 w-full rounded-lg bg-amber-500 px-3 py-2 text-sm font-bold text-white disabled:cursor-not-allowed disabled:bg-slate-200 disabled:text-slate-500"
        >
          Marcar postergados como prioridad
        </button>
      )}
      <label className="mb-2 flex items-center gap-2 rounded-lg border border-slate-200 px-2 py-2 text-sm">
        <Search className="h-4 w-4 text-slate-400" />
        <input
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          placeholder="Buscar ID, cliente, distrito"
          className="min-w-0 flex-1 border-0 outline-none"
        />
      </label>
      <div className="max-h-[360px] space-y-1 overflow-y-auto">
        {filtered.map((delivery) => (
          <div key={delivery.id} className="flex w-full items-center justify-between gap-2 rounded-lg border border-slate-200 px-2 py-2 text-left text-sm">
            <span className="min-w-0">
              <span className="block truncate font-bold text-slate-900">#{delivery.id} {delivery.recipient_name}</span>
              <span className="block truncate text-xs text-slate-500">
                {delivery.district || 'Sin distrito'} | slot {delivery.slot || 0}
                {String(delivery.status || '').toLowerCase() === 'postergado' && (
                  <span className="ml-1 font-bold text-amber-700">| postergado</span>
                )}
              </span>
            </span>
            <button
              onClick={() => onTogglePriority(delivery)}
              className="shrink-0 rounded-lg border border-slate-200 p-1.5"
              title={delivery.priority ? 'Quitar prioridad' : 'Marcar prioridad'}
            >
              <Star className={`h-4 w-4 ${delivery.priority ? 'fill-amber-400 text-amber-500' : 'text-slate-300'}`} />
            </button>
          </div>
        ))}
        {!filtered.length && (
          <div className="rounded-lg bg-slate-50 p-3 text-center text-sm font-semibold text-slate-500">
            No hay entregas en esta vista.
          </div>
        )}
      </div>
    </div>
  );
}

export default RoutePlannerPriorityList;
